import {
  Box,
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  MenuItem,
  Card,
  CardContent,
  Snackbar,
  Alert,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useState } from "react";

export default function ApplyJob() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Show thank you message
    setSubmitted(true);

    // Refresh page after 2 seconds
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  return (
    <Box sx={{ backgroundColor: "#0b0f1a", color: "#fff", minHeight: "100vh" }}>
      {/* ===== HEADER ===== */}
      <Box
        sx={{
          py: { xs: 6, md: 8 },
          textAlign: "center",
          background: "linear-gradient(135deg, #0b0f1a, #12172a)",
        }}
      >
        <Container>
          <Typography variant="h4" fontWeight={700} gutterBottom>
            Apply for a Position
          </Typography>
          <Typography sx={{ opacity: 0.85, maxWidth: 700, mx: "auto" }}>
            Join Nerdshub and work with cutting-edge technologies, global
            clients, and a passionate engineering team.
          </Typography>
        </Container>
      </Box>

      {/* ===== FORM ===== */}
      <Container sx={{ py: 8 }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={8}>
            <Card sx={{ backgroundColor: "#12172a", borderRadius: 3 }}>
              <CardContent sx={{ p: 4 }}>
                <Typography variant="h5" fontWeight={600} gutterBottom>
                  Candidate Details
                </Typography>

                <form onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Full Name"
                        fullWidth
                        required
                        InputLabelProps={{ style: { color: "#9ca3af" } }}
                        InputProps={{ style: { color: "#fff" } }}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Email Address"
                        type="email"
                        fullWidth
                        required
                        InputLabelProps={{ style: { color: "#9ca3af" } }}
                        InputProps={{ style: { color: "#fff" } }}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Phone Number"
                        fullWidth
                        required
                        InputLabelProps={{ style: { color: "#9ca3af" } }}
                        InputProps={{ style: { color: "#fff" } }}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        select
                        label="Position Applied For"
                        fullWidth
                        required
                        InputLabelProps={{ style: { color: "#9ca3af" } }}
                        InputProps={{ style: { color: "#fff" } }}
                      >
                        <MenuItem value="frontend">Frontend Developer</MenuItem>
                        <MenuItem value="backend">Backend Developer</MenuItem>
                        <MenuItem value="ai">AI / ML Engineer</MenuItem>
                        <MenuItem value="devops">DevOps Engineer</MenuItem>
                      </TextField>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        label="Years of Experience"
                        fullWidth
                        InputLabelProps={{ style: { color: "#9ca3af" } }}
                        InputProps={{ style: { color: "#fff" } }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        label="Why do you want to join Nerdshub?"
                        multiline
                        rows={4}
                        fullWidth
                        InputLabelProps={{ style: { color: "#9ca3af" } }}
                        InputProps={{ style: { color: "#fff" } }}
                      />
                    </Grid>

                    {/* ===== FILE UPLOAD ===== */}
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<UploadFileIcon />}
                        sx={{
                          color: "#ff0080",
                          borderColor: "#ff0080",
                          textTransform: "none",
                        }}
                      >
                        Upload Resume (PDF/DOC)
                        <input type="file" hidden />
                      </Button>
                    </Grid>

                    {/* ===== SUBMIT ===== */}
                    <Grid item xs={12}>
                      <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{
                          mt: 2,
                          py: 1.3,
                          background:
                            "linear-gradient(135deg, #ff2d8d, #ff6aa2)",
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: 16,
                        }}
                      >
                        Submit Application
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* ===== THANK YOU MESSAGE ===== */}
      <Snackbar open={submitted} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity="success" sx={{ fontWeight: 600 }}>
          Thank you! Your application has been submitted successfully.
        </Alert>
      </Snackbar>
    </Box>
  );
}
